// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-password {
  max-width: 450px;
  width: 90%;
}

.modal-password .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.modal-password .modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.modal-password .modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  transition: color 0.2s;
}

.modal-password .modal-close-btn:hover {
  color: var(--text-primary);
}

.modal-password .modal-close-btn ion-icon {
  font-size: 1.5rem;
}

.modal-password .modal-body {
  padding: 1.5rem;
}

.modal-message {
  margin-bottom: 1.5rem;
  color: var(--text-secondary);
  line-height: 1.5;
}

.password-input-group {
  margin-bottom: 1.5rem;
}

.password-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary);
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  width: 100%;
  padding: 0.75rem;
  padding-right: 2.5rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

/* Hide browser's native password reveal button */
.password-input::-ms-reveal,
.password-input::-ms-clear {
  display: none;
}

.password-input::-webkit-credentials-auto-fill-button,
.password-input::-webkit-password-toggle-button {
  display: none;
}

.password-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.1);
}

.password-input.error {
  border-color: var(--error-color);
}

.password-toggle-btn {
  position: absolute;
  right: 0.5rem;
  padding: 0.25rem;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-toggle-btn:hover {
  color: var(--text-primary);
}

.password-toggle-btn ion-icon {
  font-size: 1.25rem;
}

.password-error {
  display: block;
  margin-top: 0.5rem;
  color: var(--error-color);
  font-size: 0.875rem;
}

.modal-password .modal-footer {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  padding-top: 1rem;
}

.password-modal-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}

.password-modal-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.password-modal-btn-cancel {
  background-color: white;
  color: rgba(106, 106, 106, 1);
  border: 1px solid rgba(106, 106, 106, 1);
}

.password-modal-btn-cancel:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}

.password-modal-btn-confirm {
  background-color: var(--netsfere-red, rgb(222, 72, 88));
  color: white;
}

.password-modal-btn-confirm:hover:not(:disabled) {
  background-color: rgb(200, 62, 78);
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/PasswordInputModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".modal-password {\n  max-width: 450px;\n  width: 90%;\n}\n\n.modal-password .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.modal-password .modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.modal-password .modal-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  transition: color 0.2s;\n}\n\n.modal-password .modal-close-btn:hover {\n  color: var(--text-primary);\n}\n\n.modal-password .modal-close-btn ion-icon {\n  font-size: 1.5rem;\n}\n\n.modal-password .modal-body {\n  padding: 1.5rem;\n}\n\n.modal-message {\n  margin-bottom: 1.5rem;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.password-input-group {\n  margin-bottom: 1.5rem;\n}\n\n.password-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input {\n  width: 100%;\n  padding: 0.75rem;\n  padding-right: 2.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n/* Hide browser's native password reveal button */\n.password-input::-ms-reveal,\n.password-input::-ms-clear {\n  display: none;\n}\n\n.password-input::-webkit-credentials-auto-fill-button,\n.password-input::-webkit-password-toggle-button {\n  display: none;\n}\n\n.password-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.1);\n}\n\n.password-input.error {\n  border-color: var(--error-color);\n}\n\n.password-toggle-btn {\n  position: absolute;\n  right: 0.5rem;\n  padding: 0.25rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.password-toggle-btn:hover {\n  color: var(--text-primary);\n}\n\n.password-toggle-btn ion-icon {\n  font-size: 1.25rem;\n}\n\n.password-error {\n  display: block;\n  margin-top: 0.5rem;\n  color: var(--error-color);\n  font-size: 0.875rem;\n}\n\n.modal-password .modal-footer {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  padding-top: 1rem;\n}\n\n.password-modal-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n}\n\n.password-modal-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.password-modal-btn-cancel {\n  background-color: white;\n  color: rgba(106, 106, 106, 1);\n  border: 1px solid rgba(106, 106, 106, 1);\n}\n\n.password-modal-btn-cancel:hover:not(:disabled) {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.password-modal-btn-confirm {\n  background-color: var(--netsfere-red, rgb(222, 72, 88));\n  color: white;\n}\n\n.password-modal-btn-confirm:hover:not(:disabled) {\n  background-color: rgb(200, 62, 78);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
